import { UserTableSettingsDto } from '@/core';
import { ColumnsType } from 'antd/lib/table';
import { useMemo } from 'react';
import { createColumnOptions, selectHidden } from './columnSettingsUtils';

export function useColumnOptions<T>(
  columns: ColumnsType<T> | undefined,
  settings: Pick<Partial<UserTableSettingsDto>, 'hiddenColumns'> | undefined,
  defaultHiddenColumnKeys?: string[],
) {
  return useMemo(() => {
    const workingColumns = (columns || []).filter(
      (column) => column.title && column.key,
    );
    const columnOptions = createColumnOptions(
      workingColumns,
      settings,
      defaultHiddenColumnKeys,
    );
    const hiddenColumnKeys = selectHidden(columnOptions);

    return {
      columnOptions,
      hiddenColumnKeys,
      visibleColumns: columns?.filter(
        (column) =>
          !column.key ||
          !hiddenColumnKeys.split(',').includes(column.key.toString()),
      ),
    };
  }, [columns, defaultHiddenColumnKeys, settings]);
}
